import { Button, TableColumnsType } from "antd";
import { DownloadOutlined, SendOutlined } from "@ant-design/icons";

import { OrdersTableType } from "../../models";

export const ordersColumns = (
  setModalVisible: (id: string) => void,
  orderDownload: (id: string) => void
): TableColumnsType<OrdersTableType> => {
  const columns: TableColumnsType<OrdersTableType> = [
    {
      title: "NASLOV",
      dataIndex: ["offerRequest", "name"],
      render: (name) => <span className="text-primary">{name}</span>,
    },
    {
      title: "PREUZMI NALOG",
      width: 150,
      align: "center",
      render: (record) => (
        <Button
          className="text-xs sm:text-sm px-2 sm:px-4 text-white bg-primary font-medium rounded-sm border-primary shadow-sm"
          icon={<DownloadOutlined />}
          onClick={() => orderDownload(record.key)}
        >
          PREUZMI
        </Button>
      ),
    },
    {
      title: "POŠALJI OVJEREN NALOG",
      width: 220,
      align: "center",
      render: (record) => (
        <Button
          onClick={() => setModalVisible(record.key)}
          className="text-xs sm:text-sm px-2 sm:px-4 text-white bg-primary font-medium rounded-sm border-primary shadow-sm"
          icon={<SendOutlined />}
        >
          POŠALJI
        </Button>
      ),
    },
  ];

  return columns;
};
